import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import networkingImage from '../../assets/network-installation.jpg'; // Replace with your image

const Networking = () => {
  return (
    <section className="bg-[#f4f6f7] py-20">
      <div className="container mx-auto px-8 md:px-6">
        {/* Hero Section */}
        <h1 className="text-3xl md:text-4xl font-semibold text-[#023B8D] text-center mb-8">
          Networking Services
        </h1>

        {/* Main Content Section */}
        <div className="flex flex-col lg:flex-row items-stretch justify-between">
          
          {/* Image Section */}
          <div className="lg:w-1/3 flex-grow flex-shrink-0 lg:h-auto h-64 md:h-96">
            <img
              src={networkingImage}
              alt="Networking Solutions Display"
              className="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* Content Section */}
          <div className="p-5 md:p-10 text-left lg:w-1/6 flex-grow lg:ml-8 mt-8 lg:mt-0 flex items-center">
            <div>
              <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-6">
                Our networking solutions are designed to enhance connectivity and ensure efficient communication across your organization. We provide end-to-end support for your networking needs, from setup to ongoing maintenance.
              </p>

              <h2 className="text-2xl md:text-3xl text-[#023B8D] mb-4">
                Our Networking Services
              </h2>
              <ul className="text-base md:text-lg text-gray-700 space-y-2">
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Network Design & Implementation</li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Wireless Network Setup</li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Network Cabling</li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Network Troubleshooting & Support</li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Network printer connection</li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> VPN & Remote Access Solutions</li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Network Configuration </li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Server installation</li>
                <li><span ><FontAwesomeIcon icon={faCheckCircle} className="text-blue-900 mt-1 mr-2" /></span> Backup systems both onsite and off-site
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5 md:py-6">
        <div className="container mx-auto text-center">
          <h2 className="text-lg md:text-3xl text-[#023B8D] mb-6 md:mb-8 animate-bounce">
            Enhance Your Network Today!
          </h2>
          <p className="text-base md:text-xl text-gray-700 mb-6 md:mb-8 animate-fadeIn delay-1s">
            Get in touch with us to optimize and secure your network infrastructure.
          </p>
          <Link to="/ContactPage">
            <button className="bg-[#C5B358] text-blue-900 font-semibold py-2 md:py-3 px-6 md:px-8 rounded-full transition duration-300 hover:bg-[#c39e2a] hover:scale-110 animate-pulse">
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Networking;
